<template>
  <svg class="svg-icon" :class="[name, modifierClass]">
    <use :xlink:href="href" />
  </svg>
</template>

<script>
export default {
  name: 'Icon',
  props: {
    modifier: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: true
    },
    name: {
      type: String
    },
    id: {
      type: String
    }
  },
  data: function () {
    return {
      block: 'svg-icon--'
    }
  },
  computed: {
    modifierClass () {
      if (this.modifier.length) {
        return this.modifier.split(' ').map(m => this.block + m).join(' ')
      } else {
        return ''
      }
    },
    href () {
      if (this.show) {
        let path = process.env.NODE_ENV === 'development' ? '/static/svg-sprite.svg#' : '/themes/custom/tryg/dist/svg/svg-sprite.svg#'
        return path + this.id
      } else {
        return ''
      }
    }
  }
}
</script>

<style scoped>
.svg-icon {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  fill: currentColor !important;
}
.svg-icon--radio,
.svg-icon--checkbox {
  margin:0 .5rem;
}
.svg-icon--radio {
  border:0.066rem solid currentColor;
  border-radius:50%;
}
.svg-icon--checkbox {
  border:0.066rem solid currentColor;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Icon.vue